module.exports = __webpack_public_path__ + "img/img4.1d92a874.svg";